import { connect } from 'react-redux';

import OutreachView from './OutreachView.jsx';
import { getIntegrationForType, fetchIntegrations } from 'src/legacy/redux/actions/integrations.jsx';
import { authenticateAccount } from 'src/legacy/redux/actions/integrations/outreach.jsx';
import { trackAdoptionMetricsForPluginConnectedEvent } from "src/legacy/redux/actions/adoption";
import _ from 'lodash';
import withUseHooks from 'src/legacy/components/withUseHooks.jsx';

const mapStateToProps = (state, ownProps) => {
  let integration = getIntegrationForType(state, 'outreach');
  return {
    integration: integration,
    integrations: state.legacyRootReducer.settings.integrations,
    authenticating: state.legacyRootReducer.settings.integrations.outreach.authentication.authenticating,
    user: state.users.me,
    deactivating: state.legacyRootReducer.settings.integrations.activated.deactivating.loading,
    user: _.get(state, 'users.me', ""),
    integrationsLoading: _.get(state.legacyRootReducer.settings.integrations, 'activated.loading', false)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authenticateAccount: (code) => {
      return dispatch(authenticateAccount(code));
    },

    fetchIntegrations: () => {
      return dispatch(fetchIntegrations());
    },
    trackAdoptionMetricsForPluginConnectedEvent: (partnerName) => {
      return dispatch(trackAdoptionMetricsForPluginConnectedEvent(partnerName));
    }
  }
}

const OutreachPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(OutreachView);

export default withUseHooks(OutreachPage);
